import { render, staticRenderFns } from "./ServicesType.vue?vue&type=template&id=44aedf6c&scoped=true&"
import script from "./ServicesType.vue?vue&type=script&lang=js&"
export * from "./ServicesType.vue?vue&type=script&lang=js&"
import style0 from "./ServicesType.vue?vue&type=style&index=0&id=44aedf6c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aedf6c",
  null
  
)

export default component.exports